import React from 'react';
import { injectIntl } from 'react-intl-next';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import InfoIcon from '@atlaskit/icon/core/migration/information--info';
import SuccessIcon from '@atlaskit/icon/core/migration/success--check-circle';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import { G300, P300, R300, Y300 } from '@atlaskit/theme/colors';
import messages from './messages';
var ErrorWithIntl = injectIntl(function (_ref) {
  var intl = _ref.intl;
  return /*#__PURE__*/React.createElement(ErrorIcon, {
    color: "var(--ds-icon-danger, ".concat(R300, ")"),
    LEGACY_size: "medium",
    label: intl.formatMessage(messages.error)
  });
});
var WarningWithIntl = injectIntl(function (_ref2) {
  var intl = _ref2.intl;
  return /*#__PURE__*/React.createElement(WarningIcon, {
    color: "var(--ds-icon-warning, ".concat(Y300, ")"),
    LEGACY_size: "medium",
    label: intl.formatMessage(messages.warning)
  });
});
var InfoWithIntl = injectIntl(function (_ref3) {
  var intl = _ref3.intl;
  return /*#__PURE__*/React.createElement(InfoIcon, {
    color: "var(--ds-icon-discovery, ".concat(P300, ")"),
    LEGACY_size: "medium",
    label: intl.formatMessage(messages.info)
  });
});
var SuccessWithIntl = injectIntl(function (_ref4) {
  var intl = _ref4.intl;
  return /*#__PURE__*/React.createElement(SuccessIcon, {
    color: "var(--ds-icon-success, ".concat(G300, ")"),
    LEGACY_size: "medium",
    label: intl.formatMessage(messages.success)
  });
});
export var errorToastProps = function errorToastProps() {
  return {
    icon: /*#__PURE__*/React.createElement(ErrorWithIntl, null),
    appearance: 'normal'
  };
};
export var warningToastProps = function warningToastProps() {
  return {
    icon: /*#__PURE__*/React.createElement(WarningWithIntl, null),
    appearance: 'normal'
  };
};
export var infoToastProps = function infoToastProps() {
  return {
    icon: /*#__PURE__*/React.createElement(InfoWithIntl, null),
    appearance: 'normal'
  };
};
export var successToastProps = function successToastProps() {
  return {
    icon: /*#__PURE__*/React.createElement(SuccessWithIntl, null),
    appearance: 'normal',
    isAutoDismiss: true
  };
};